// Curated themes shown as a horizontal carousel.
//
// Static data — these are MARKETING categories, not catalog items. Each routes to a
// pre-filled /hotels/search (the only live-bookable category today). Once flights/tours
// modules go live, swap the `to` field per theme.
export const TRAVEL_THEMES = [
  {
    id: 'beach',
    title: 'Beach Escapes',
    sub: 'Goa · Maldives · Andaman',
    image: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&q=80',
    accent: 'from-sky-500/40 to-sky-900/80',
    to: '/hotels/search?city=Goa',
  },
  {
    id: 'hill',
    title: 'Hill Stations',
    sub: 'Shimla · Manali · Munnar',
    image: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=800&q=80',
    accent: 'from-emerald-500/30 to-emerald-900/80',
    to: '/hotels/search?city=Manali',
  },
  {
    id: 'heritage',
    title: 'Heritage Cities',
    sub: 'Jaipur · Udaipur · Agra',
    image: 'https://images.unsplash.com/photo-1599661046289-e31897846e41?w=800&q=80',
    accent: 'from-amber-500/30 to-amber-900/80',
    to: '/hotels/search?city=Jaipur',
  },
  {
    id: 'spiritual',
    title: 'Spiritual Trails',
    sub: 'Varanasi · Rishikesh · Tirupati',
    image: 'https://images.unsplash.com/photo-1561361513-2d000a50f0dc?w=800&q=80',
    accent: 'from-orange-500/30 to-orange-900/80',
    to: '/hotels/search?city=Varanasi',
  },
  {
    id: 'metro',
    title: 'Metro Weekends',
    sub: 'Mumbai · Bengaluru · Delhi',
    image: 'https://images.unsplash.com/photo-1570168007204-dfb528c6958f?w=800&q=80',
    accent: 'from-rose-500/30 to-rose-900/80',
    to: '/hotels/search?city=Mumbai',
  },
  {
    id: 'workation',
    title: 'Workation Picks',
    sub: 'Goa · Pondicherry · Coorg',
    image: 'https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=800&q=80',
    accent: 'from-violet-500/30 to-violet-900/80',
    to: '/hotels/search?city=Pondicherry',
  },
  {
    id: 'wildlife',
    title: 'Wildlife & Safaris',
    sub: 'Jim Corbett · Ranthambore · Kabini',
    image: 'https://images.unsplash.com/photo-1549366021-9f761d450615?w=800&q=80',
    accent: 'from-lime-500/30 to-lime-900/80',
    to: '/hotels/search?city=Jaipur',
  },
  {
    id: 'desert',
    title: 'Desert Wonders',
    sub: 'Jaisalmer · Kutch · Bikaner',
    image: 'https://images.unsplash.com/photo-1473625247510-8ceb1760943f?w=800&q=80',
    accent: 'from-yellow-500/30 to-yellow-900/80',
    to: '/hotels/search?city=Jaisalmer',
  },
];

export const TESTIMONIALS = [
  {
    id: 't1',
    name: 'Aarav Mehta',
    location: 'Mumbai',
    text:
      'Booked our anniversary stay in Goa in under 2 minutes — got a better price than the property’s own site. The real-time availability check is genuinely fast.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=200&q=80',
  },
  {
    id: 't2',
    name: 'Priya Iyer',
    location: 'Bengaluru',
    text:
      'I work in fintech and notice the little things — the price I saw was the exact price I paid. No hidden “taxes appearing at checkout” nonsense. Refreshing.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80',
  },
  {
    id: 't3',
    name: 'Rohan Khanna',
    location: 'Delhi',
    text:
      'The mobile experience is great — searched and booked a Mumbai hotel from a moving cab. Razorpay UPI worked first try. Voucher hit my inbox immediately.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=80',
  },
  {
    id: 't4',
    name: 'Meera Krishnan',
    location: 'Chennai',
    text:
      'I compared 4 OTAs for our Kerala trip. Elite Travo had the cleanest interface and the most transparent fees. Support was actually human when I called.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&q=80',
  },
  {
    id: 't5',
    name: 'Vikram Singh',
    location: 'Jaipur',
    text:
      'Used the business mode for a client trip. Got a GST-compliant invoice instantly. Will roll this out company-wide next quarter.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&q=80',
  },
];
